import React from 'react'
import { Link } from 'react-router-dom'
import { Heart, Shield, Zap } from 'lucide-react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-gradient-purple p-2 rounded-lg">
                <Zap className="h-6 w-6 text-white" />
              </div>
              <span className="text-xl font-bold">SnapTools</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Professional image and document processing tools built for speed, privacy, and reliability. 
              All processing happens securely in your browser and on Cloudflare's edge network.
            </p>
            <div className="flex items-center space-x-4 text-sm text-gray-400">
              <div className="flex items-center space-x-1">
                <Shield className="h-4 w-4" />
                <span>Secure & Private</span>
              </div>
              <div className="flex items-center space-x-1">
                <Zap className="h-4 w-4" />
                <span>Lightning Fast</span>
              </div>
            </div>
          </div>

          {/* Image Tools */}
          <div>
            <h3 className="font-semibold mb-4">Image Tools</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/image/convert" className="hover:text-white transition-colors">
                  Convert Format
                </Link>
              </li>
              <li>
                <Link to="/image/resize" className="hover:text-white transition-colors">
                  Resize Images
                </Link>
              </li>
              <li>
                <Link to="/image/compress" className="hover:text-white transition-colors">
                  Compress Images
                </Link>
              </li>
            </ul>
          </div>

          {/* PDF Tools */}
          <div>
            <h3 className="font-semibold mb-4">PDF Tools</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/pdf/merge" className="hover:text-white transition-colors">
                  Merge PDFs
                </Link>
              </li>
              <li>
                <Link to="/pdf/split" className="hover:text-white transition-colors">
                  Split PDFs
                </Link>
              </li>
              <li>
                <Link to="/pdf/compress" className="hover:text-white transition-colors">
                  Compress PDFs
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2025 SnapTools. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                About
              </Link>
              <div className="flex items-center space-x-1 text-gray-400">
                <span>Made with</span>
                <Heart className="h-3 w-3 text-red-500" />
                <span>by SnapTools Team</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
